import { render, staticRenderFns } from "./LPRCard.vue?vue&type=template&id=65abe81e"
import script from "./LPRCard.vue?vue&type=script&lang=js"
export * from "./LPRCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports